<template>
    <b-modal
      id="registration-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
    >
      <div class="header">
        <span class="close-icon"
              @click="closeModal">
          <img src="@/assets/svg/close.svg"
               aria-label="close">
        </span>

        <h3 class="reg-title">регистрация</h3>

        <h5 class="reg-title">
          Поля, отмеченные *,  являются <br> обязательными к заполнению
        </h5>
      </div>

      <form ref="form"
            class="modal-form"
            @submit.stop.prevent="submit">
        <!-- <b-form-group
          id="surname-input"
          label-for="surname-input"
          :invalid-feedback="invalidSurname"
        >
          <b-form-input
            id="surname-input"
            placeholder="Фамилия"
            required
            type="text"
            pattern="[A-Za-z]+"
            :class="{ 'is-invalid' : isInvalidSurname }"
            v-model="$v.item.surname.$model"
            :state="validateState($v.item.surname)"
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.surname">*</span>
        </b-form-group> -->

        <b-form-group
          id="name-input"
          label-for="name-input"
          :invalid-feedback="invalidName"
        >
          <b-form-input
            id="name-input"
            placeholder="Имя"
            required
            type="text"
            pattern="[A-Za-z]+"
            :class="{ 'is-invalid' : isInvalidName }"
            v-model="$v.item.name.$model"
            :state="validateState($v.item.name)"
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.name">*</span>
        </b-form-group>

        <b-form-group
          label-for="name-input"
          :invalid-feedback="invalidEmail"
        >
          <b-form-input
            id="name-input"
            placeholder="Email"
            type="email"
            required
            ref="email"
            v-model="$v.item.email.$model"
            :class="{ 'is-invalid' : isInvalidEmail, 'is-valid' : !isInvalidEmail  }"
            :state="validateState($v.item.email)"
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.email">*</span>
        </b-form-group>

        <b-form-group
          id="birthdate-input"
          label-for="birthdate-input"
          :invalid-feedback="invalidBirthdate"
          v-mask="'##.##.####'"
        >
          <b-form-input
            id="birthdate-input"
            placeholder="Дата рождения"
            required
            ref="birthdate"
            v-model="$v.item.birthdate.$model"
            :class="{ 'is-invalid' : isInvalidBirthdate, 'is-valid' : !isInvalidBirthdate }"
            :state="validateState($v.item.birthdate)"
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.birthdate">*</span>
        </b-form-group>

        <!-- <b-form-group
          label-for="name-input"
          :invalid-feedback="invalidPhone"
          v-mask="'+7(###)-###-##-##'"
        >
          <b-form-input
            id="name-input"
            @click="putPlaceholder"
            placeholder="Мобильный телефон без +7"
            v-model="$v.item.phone.$model"
            maxlength="17"
            ref="phone"
            :class="{ 'is-invalid' : isInvalidPhone, 'is-valid' : !isInvalidPhone }"
            :state="validateState($v.item.phone)"
            required
          ></b-form-input>

          <span class="input-icon"
                v-if="!item.phone">*</span>
       </b-form-group> -->

       <b-form-checkbox
         id="checkbox-rules"
         v-model="$v.item.rules.$model"
         :state="validateState($v.item.rules)"
         class="mt-4"
         name="rules"
         value="true"
         unchecked-value="not_accepted"
       >
         Я прочитал и принимаю условия
         <b-link :href="rulesLink"
                 target="_blank">Правил акции</b-link> и

         <b-link :href="userAgreementLink"
                 target="_blank">Пользовательского соглашения</b-link>
       </b-form-checkbox>

       <b-form-checkbox
         id="pol-rules"
         v-model="$v.item.policies.$model"
         :state="validateState($v.item.policies)"
         class="mt-4"
         name="pol"
         value="true"
         unchecked-value="not_accepted"
       >
         Я прочитал и согласен на
         <b-link :href="personalDataLink"
                 target="_blank">обработку персональных данных</b-link>
       </b-form-checkbox>

       <div class="w-100 d-flex justify-content-center mt-4">
          <div id="captcha-container-reg"></div>
       </div>
      </form>

      <b-button class="button button-green button-green-bg"
                type="submit"
                :disabled="disabledBtn || submittedBtn"
                @click="submit"
                onclick="ym(108239013,'reachGoal','registration_ckick')">продолжить</b-button>
    </b-modal>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
import { validationMixin } from "vuelidate"
import { mapState, mapGetters, mapMutations } from "vuex"
import { required, requiredIf, minLength, maxLength, or, helpers } from "vuelidate/lib/validators"

const text = helpers.regex('text', /^[?!,.а-яА-ЯёЁ\s]+$/)
const email = helpers.regex('email', /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
const number = helpers.regex('number', /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)
const token = localStorage.getItem('token-bockarev')

  export default {
    mixins: [validationMixin],

    components: {
      VueRecaptcha
    },

    validations: {
      item: {
        surname: {
          minLength: minLength(2),
          maxLength: maxLength(20),
          text,
        },
        name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
          text,
        },
        birthdate: {
          required,
          minLength: minLength(10),
          maxLenght: maxLength(10),
          number,
        },
        phone: {
          minLength: minLength(17),
          maxLength: maxLength(17),
        },
        email: {
          required,
          minLength: minLength(4),
          email
        },
        rules: {
          required
        },
        policies: {
          required
        },
        recaptchaResponse: {
        }
      }
    },

    data() {
      return {
        item: {
          surname: '',
          name: '',
          phone: '',
          birthdate: '',
          email: '',
          rules: '',
          policies: '',
          recaptchaResponse: ''
        },
        widgetId: null,
        rulesLink: '',
        personalDataLink: '',
        userAgreementLink: '',
        submittedBtn: false,
        isInvalidSurname: false,
        isInvalidName: false,
        isInvalidPhone: false,
        isInvalidBirthdate: false,
        isInvalidEmail: false,
        invalidSurname: 'Некорректное поле',
        invalidName: 'Некорректное поле',
        invalidPhone: 'Некорректное поле',
        invalidBirthdate: 'Некорректное поле',
        invalidEmail: 'Некорректное поле',
        recaptcha: null,
        isInvalidCaptcha: false,
        invalidCaptcha: 'Некорректное поле'
      }
    },

    computed: {
      ...mapGetters({
        documents: 'documents',
        storeRules: 'rules',
        storePrivacyPolicy: 'privacyPolicy',
        storePersonalData: 'personalData',
        storeUserAgremeent: 'userAgreement'
      }),

      disabledBtn(){
        if (this.$v.item.$anyError)
          return true
      }
    },

    watch: {
    },

    mounted(){
      this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
        if (modalId == "registration-modal") {
          this.rulesLink = this.storeRules.url
          this.userAgreementLink = this.storeUserAgremeent.url
          this.personalDataLink = this.storePersonalData.url

          setTimeout(() => {
            if (window.smartCaptcha) {
            this.renderCaptcha()
            } else {
              window.onSmartCaptchaLoad = this.renderCaptcha
            }
          }, 500)
        }
      })
    },

    methods: {
      ...mapMutations({
        saveUser: 'saveUser',
        saveToken: 'saveToken'
      }),

      renderCaptcha() {
        this.widgetId = window.smartCaptcha.render('captcha-container-reg', {
          sitekey: 'ysc1_cS8OaHyfLaHdYM7azFhnM84ck956BhgzOAVycwjgc9863942',
          callback: this.onCaptchaPassed,
        });
      },

      onCaptchaPassed(token) {
        this.item.recaptchaResponse = token // Store token for form submission
        this.$emit('validated', token)
      },

      resetCaptcha() {
        if (this.widgetId !== null) {
          window.smartCaptcha.reset(this.widgetId) // Reset for reuse
        }
      },

      resetModal() {
        this.$bvModal.hide('registration-modal')
        this.$bvModal.show('success-modal')

        this.$v.$reset()

        this.item.name = '',
        this.item.email = '',
        this.submittedBtn = false,
        this.item.surname= '',
        this.item.phone = '',
        this.item.birthdate = '',
        this.item.rules = '',
        this.item.policies = '',
        this.item.recaptchaResponse = '',
        this.isInvalidSurname = false,
        this.isInvalidName = false,
        this.isInvalidPhone = false,
        this.isInvalidBirthdate = false,
        this.isInvalidEmail = false,
        this.isInvalidCaptcha = false,
        this.invalidCaptcha = 'Некорректное поле'
        this.invalidSurname = 'Некорректное поле',
        this.invalidName = 'Некорректное поле',
        this.invalidPhone = 'Некорректное поле',
        this.invalidBirthdate = 'Некорректное поле',
        this.invalidEmail = 'Некорректное поле'
      },

      closeModal(){
        this.$v.$reset()

        this.item.name = '',
        this.item.email = '',
        this.submittedBtn = false,
        this.item.surname= '',
        this.item.phone = '',
        this.item.birthdate = '',
        this.item.rules = '',
        this.item.policies = '',
        this.item.recaptchaResponse = '',
        this.isInvalidSurname = false,
        this.isInvalidName = false,
        this.isInvalidPhone = false,
        this.isInvalidBirthdate = false,
        this.isInvalidEmail = false,
        this.isInvalidCaptcha = false,
        this.invalidCaptcha = 'Некорректное поле'
        this.invalidSurname = 'Некорректное поле',
        this.invalidName = 'Некорректное поле',
        this.invalidPhone = 'Некорректное поле',
        this.invalidBirthdate = 'Некорректное поле',
        this.invalidEmail = 'Некорректное поле'

        this.$bvModal.hide('registration-modal')
      },

      validateState(item) {
        const { $dirty, $error } = item
        return $dirty ? !$error : null
      },

      onCaptchaVerified(recaptchaToken) {
        this.item.recaptchaResponse = recaptchaToken
      },

      submit() {
        this.submittedBtn = true
        this.$v.item.$touch()

        if (this.$v.item.$anyError)
          return false

        axios.post('auth/register', {
          name: this.item.name,
          email: this.item.email,
          birthday: this.item.birthdate,
          accept_rules: this.item.rules,
          accept_personal_data: this.item.policies,
          accept_user_agreement: this.item.policies,
          "smart-captcha-response": this.item.recaptchaResponse
        }, {
          headers: {
            'Accept': "application/json",
            'Content-Type': "application/json",
            'access-control-allow-origin': "*"
          }
        }).then((response) => {
          ym(108239013,'reachGoal','registration_send')

          this.resetModal()
        }).catch((error) => {
          this.resetCaptcha()
          this.submittedBtn = false

          if (error.response.data.message === "Невозможно создать токен, обратитесь в техподдержку."){
            this.$emit('getErrorText', error.response.data.message)

            this.closeModal()
            this.$bvModal.show('error-modal')
          } if (!!error.response.data.errors.email){
            this.isInvalidEmail = true
            this.invalidEmail = error.response.data.errors.email[0]
          } if (!!error.response.data.errors.birthday){
            this.isInvalidBirthdate = true
            this.invalidBirthdate = error.response.data.errors.birthday[0]

          } if (!!error.response.data.errors.phone){
            this.isInvalidPhone = true
            this.invalidPhone = error.response.data.errors.phone[0]
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
.button {
  margin-top: 40px;
  width: 100%;
  border: 1px solid $black !important;

  &:hover {
    opacity: 0.8 !important;
  }

  @media(max-width: 576px) {
    margin-top: 0;
  }
}

a {
  color: #FBD6A1 !important;
  text-decoration: underline;
}

h5 {
  color: white;
  margin-top: 10px;
  font-family: $regular;
  font-size: 18px;
  line-height: 116%;

  @media(max-width: 576px) {
    font-size: 14px;
  }
}

.captcha {
  display: flex;
  justify-content: center;
  width: 100% !important;
  transform: scale(125%);
  margin-top: 20px;
  margin-bottom: 20px;

  @media(max-width: 400px){
    transform: scale(100%);
  }

  @media(max-width: 350px){
    transform: scale(90%);
  }
}

.header {
  margin-bottom: 28px !important;

  @media(max-width: 576px) {
    margin-bottom: 22px !important;
  }
}
</style>
